<div class="no-data">
  <span class="text-center">{{ message }}</span>
</div>
